import toastStore, { ToastType } from './toastService';

/**
 * Creates and displays a toast notification
 * @param message The message to display
 * @param type Type of toast (success, error, warning, info)
 * @param duration Duration in milliseconds (default: 5000ms)
 */
export function createToast(message: string, type: ToastType = 'info', duration = 5000): void {
  toastStore.show(message, type, duration);
}

/**
 * Removes a toast notification by ID
 * @param id The toast ID to remove
 */
export function removeToast(id: number): void {
  toastStore.remove(id);
}

export default {
  createToast,
  removeToast
}; 